import CurrencyDeterminer from "@/module/Form/Currency/CurrencyDeterminer";

export default class CountryCurrencyDeterminer implements CurrencyDeterminer {
  private readonly countryCurrencySetting: { [key: string]: string };

  constructor(countryCurrencySetting: { [key: string]: string }) {
    this.countryCurrencySetting = countryCurrencySetting;
  }

  determinate(
    selectedCurrency: string | null,
    selectedCountry: string | null,
  ): string {
    const currency = this.countryCurrencySetting["*"];

    for (const index in this.countryCurrencySetting) {
      if (index === selectedCountry) {
        return this.countryCurrencySetting[index];
      }
    }

    return currency;
  }
}
